import React, { type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Platform, StyleSheet } from 'react-native';

import { BodyText, Modal, theme, useResponsive } from '@sg/garnish';

export const BagUpsellModal = (props: BagUpsellModalProps) => {
  const { onCancel, isModalVisible, children } = props;

  const { minWidth } = useResponsive();

  return (
    <>
      {minWidth.isSM ? (
        <Modal
          visible={isModalVisible}
          size="medium"
          fitHeight
          animationType="fade"
          onRequestClose={onCancel}
        >
          <Modal.FloatingCloseBtn onPress={onCancel} style={styles.closeButton} />
          {children}
        </Modal>
      ) : (
        <Modal
          visible={isModalVisible}
          size="medium"
          fitHeight
          onRequestClose={onCancel}
          withSafeAreaView
          containerStyle={styles.floatingContainer}
          contentContainerStyle={styles.floatingContent}
        >
          <BodyText sizeMatch={['16']} bold style={styles.sheetHeaderText}>
            <FormattedMessage {...messages.header} />
          </BodyText>

          {children}
        </Modal>
      )}
    </>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  header: {
    defaultMessage: 'Add something else?',
    description: 'Bag Upsell | Modal | Header',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  floatingContainer: {
    backgroundColor: theme.colors.OPACITY.TRANSPARENT,
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: Platform.select({ default: theme.spacing['8'], web: theme.spacing['4'] }),
  },
  floatingContent: {
    borderRadius: theme.radius.xlarge,
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['6'], // NOTE: Needed for override
    paddingHorizontal: theme.spacing['4'],
    backgroundColor: theme.colors.WHITE,
  },
  sheetHeaderText: {
    textAlign: 'center',
  },
  closeButton: {
    marginTop: theme.spacing['5'],
    marginRight: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagUpsellModalProps = PropsWithChildren<{
  isModalVisible: boolean;
  onCancel: () => void;
}>;
